export const eventValueMap = {
    input: (e) => e,
    blur: (e) => e.target.value,
    focus: (e) => e.target.value,
    mouseenter: (e) => e.target.value,
    mouseleave: (e) => e.target.value
};
